import Vue from 'vue'
import Vuex from 'vuex'
import loadingSpinner from './modules/loadingSpinner'
import alertTopBar from './modules/alertTopBar'

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        loadingSpinner: loadingSpinner,
        alertTopBar: alertTopBar,
    },
    state: {
        // Account
        user: {},
        notifications: [],

        shoppingCart: null,
    },
    getters: {
        isAdmin(state) {
            return state.user.type && state.user.type == 369;
        },
        hasModulePermission(state) {
            return function (module_key) {
                if (state.user.type && state.user.type == 369) {
                    return true
                }
                return state.user.permissions && _.filter(state.user.permissions, function (p) {
                    return p.startsWith(module_key);
                }).length > 0;
            }
        },
        hasPermission(state) {
            return function (key) {
                let module_key = key.split('.')[0];

                if (state.user.type && state.user.type == 369) {
                    return true
                }
                return state.user.permissions && (state.user.permissions.indexOf(module_key) !== -1 || state.user.permissions.indexOf(key) !== -1)
            }
        },
    },
    mutations: {
        signIn(state, user) {
            state.user = user;
        },
        signOut(state) {
            state.user = {};
        },
        setNotifications(state, notifications) {
            state.notifications = notifications;
        },
        setShoppingCart(state, booking_record) {
            state.shoppingCart = booking_record;
        },
    },
    actions: {
        login({commit}, {v, username, password}) {
            v.$callAPI('login/', {
                username: username,
                company_domain: '.',
                password: password,
            }, function (response) {
                v.$storeDispatch('getMe');
            });
        },
        logout({commit}, {v}) {
            v.$callAPI('logout/', {}, function (response) {
                commit('signOut');
            }, function (response) {
                console.log('LOG OUT FAILED');
                commit('signOut');
            })
        },
        getMe({commit}, {v}) {
            v.$callAPI('hkiarace/me/', {}, function (response) {
                commit('signIn', response.body.user);
                v.$cookie.set('UID', response.body.user.id, {samesite: 'Strict', secure: true});
            }, function (response) {
                // v.$router.push({name: 'login'});
            });
        },
        getShoppingCart({commit}, {v}) {
            v.$callAPI('aafb/shopping_cart/', {}, function (response) {
                commit('setShoppingCart', response.body.booking_record);
            }, function (response) {
                // v.$router.push({name: 'login'});
            });
        },
        adminGetMe({commit}, {v}) {
            v.$callAPI('hkiarace/admin/me/', {}, function (response) {
                commit('signIn', response.body.admin);
            }, function (response) {
                // v.$router.push({name: 'login'});
            });
        },
        getNotifications({commit, state}, {v}) {
            if (state.user.id) {
                // v.$callAPI('notifications/', {}, function (response) {
                //     commit('setNotifications', response.body.notifications);
                // }, function (response) {
                //     console.log('getNotifications Failed');
                // }, true);
            }
        },
    }
})
